<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-copyright element-without-heading" id="copyright">
<div class="text" id="copyright-text">
<p class="first first-in-chapter first-full-width copyright-content">This is a work of fiction. Names, characters, organizations, places, events, and incidents are either products of the author’s imagination or are used fictitiously.</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">Text copyright © 2014 CJ Lyons</p>
<p class="subsq copyright-content">All rights reserved.</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">No part of this book may be reproduced, or stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without express written permission of the publisher.</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">Published by Thomas &amp; Mercer, Seattle</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">www.apub.com</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">Amazon, the Amazon logo, and Thomas &amp; Mercer are trademarks of Amazon.com, Inc., or its affiliates.</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">ISBN-13: 9781477825785</p>
<p class="subsq copyright-content">ISBN-10: 1477825789</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">Cover design by Inkd</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">Library of Congress Control Number: [TK]</p>
<p class="implicit-break basic-break"></p>
<p class="first first-in-section first-full-width copyright-content">Printed in the United States of America</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?19c9d9b6